import debounce from 'lodash/debounce';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DOMUtils from '@spothero/utils/dom';
import Header from './header/Header';
import SearchContainer from './search/SearchContainer';
import EventList from './event/EventList';
import MapContainer from './map/MapContainer';
import StorageUtils from 'storage-utils';
import AffiliateAPI from '../api/affiliate';

const AFFILIATE_COOKIE_NAME = 'sha_affiliate';

class WidgetContent extends Component {
    constructor(props) {
        super(props);

        this._affiliateCookieIsSet = false;
        this._onWindowResize = this._onWindowResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', debounce(this._onWindowResize, 100));

        this._onWindowResize();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.currentPage !== this.props.currentPage) {
            this._content.scrollTop = 0;
            this._onWindowResize();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._onWindowResize);
    }

    _onWindowResize() {
        const navHeight = DOMUtils.height('.SH-Navigation');

        this._content.style.height = `calc(100% - ${navHeight}px)`;
    }

    _renderSearch() {
        const {
            siteUrl,
            backgroundColor,
            unbranded,
            onLogoClick,
            onMultiOrNoResultsFound
        } = this.props;

        return (
            <SearchContainer
                siteUrl={siteUrl}
                backgroundColor={backgroundColor}
                unbranded={unbranded}
                onLogoClick={onLogoClick}
                onMultiOrNoResultsFound={onMultiOrNoResultsFound}
            />
        );
    }

    _renderEvents() {
        const {
            hourSpan,
            onMultiOrNoResultsFound,
            kmlMapLayerURL,
            siteUrl,
            venueUrl,
            eventTypes,
            container,
            affiliate
        } = this.props;

        return (
            <EventList
                siteUrl={siteUrl}
                venueUrl={venueUrl}
                eventTypes={eventTypes}
                container={container}
                hourSpan={hourSpan}
                onMultiOrNoResultsFound={onMultiOrNoResultsFound}
                kmlMapLayerURL={kmlMapLayerURL}
                affiliate={affiliate}
            />
        );
    }

    _renderMap() {
        const {
            siteUrl,
            currentPage,
            searchType,
            hourSpan,
            onMultiOrNoResultsFound,
            kmlMapLayerURL,
            affiliate
        } = this.props;
        const isSearchable = (currentPage === 'search') || (currentPage === 'map' && searchType !== 'event');

        return (
            <MapContainer
                siteUrl={siteUrl}
                isSearchable={isSearchable}
                hourSpan={hourSpan}
                onMultiOrNoResultsFound={onMultiOrNoResultsFound}
                kmlMapLayerURL={kmlMapLayerURL}
                affiliate={affiliate}
            />
        );
    }

    _setAffiliateCookie() {
        const {
            affiliate
        } = this.props;

        const affiliateCookie = StorageUtils.get(AFFILIATE_COOKIE_NAME, 'cookie');

        if (affiliate && affiliateCookie !== affiliate) {
            AffiliateAPI.get(affiliate).then(({
                data: {
                    cookie_expiration: cookieExpirationInHours,
                    affiliate_code: affiliateCode
                }
            }) => {
                const cookieExpirationInDays = cookieExpirationInHours/24.0;
                StorageUtils.set(AFFILIATE_COOKIE_NAME, affiliateCode, 'cookie', cookieExpirationInDays);

                this._affiliateCookieIsSet = true;
            });
        }
    }

    render() {
        const {
            unbranded,
            title,
            subtitle,
            currentPage,
            affiliate
        } = this.props;
        const isEvent = (currentPage === 'events');
        const isSearch = (currentPage === 'search');
        const isMap = (currentPage === 'map');
        const classes = classNames(
            'SH-WidgetContent',
            {'SH-WidgetContent-searchable': isSearch},
            {'SH-WidgetContent-no-nav': unbranded && isEvent}
        );

        if ((isMap || isEvent) && affiliate && !this._affiliateCookieIsSet) {
            this._setAffiliateCookie();
        }

        return (
            <div className={classes} ref={node => { this._content = node; }}>
                {((!isSearch && !isMap && !isEvent)) &&
                    <Header
                        title={title}
                        subtitle={subtitle}
                    />
                }
                {isSearch && this._renderSearch()}
                {isEvent && this._renderEvents()}
                {isMap && this._renderMap()}
            </div>
        );
    }
}

WidgetContent.propTypes = {
    container: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    backgroundColor: PropTypes.string,
    kmlMapLayerURL: PropTypes.string,
    unbranded: PropTypes.bool,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    siteUrl: PropTypes.string.isRequired,
    searchType: PropTypes.string.isRequired,
    currentPage: PropTypes.string.isRequired,
    venueUrl: PropTypes.string,
    eventTypes: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    hourSpan: PropTypes.number.isRequired,
    onLogoClick: PropTypes.func.isRequired,
    onMultiOrNoResultsFound: PropTypes.func.isRequired,
    affiliate: PropTypes.number
};

export default WidgetContent;



// WEBPACK FOOTER //
// ./widget/src/js/components/WidgetContent.jsx